import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import tasksApiSlice from "./tasksApi/tasksSlice";
import profileApiSlice from "./profileApi/profileSlice";
import adminApiSlice from './adminApi/adminSlice';
import authReducer from "./auth/authSlice";
import dashboardReducer from "./dashboardApi/dashboardSlice";
import analyticsReducer from "./analyticsApi/analyticsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tasksApi: tasksApiSlice,
    profileApi: profileApiSlice,
    adminApi: adminApiSlice,
    dashboard: dashboardReducer,
    analytics: analyticsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/REGISTER",
        ],
      },
    }),
  devTools: true,
});

export const persistor = persistStore(store);